(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero-slideshow"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      if (root.dataset.ready) return;
      root.dataset.ready = '1';
      var track = root.querySelector('[data-track]');
      var slides = Array.prototype.slice.call(root.querySelectorAll('[data-slide]'));
      var dots = Array.prototype.slice.call(root.querySelectorAll('[data-dot]'));
      var pauseBtn = root.querySelector('[data-pause]');
      var delay = parseInt(root.dataset.autoplay || '0', 10);
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var index = 0, timer = null, userPaused = false, hovering = false;

      function go(i) {
        if (!slides.length) return;
        index = (i + slides.length) % slides.length;
        track.scrollTo({ left: slides[index].offsetLeft, behavior: reduce ? 'auto' : 'smooth' });
      }
      function mark(i) {
        index = i;
        dots.forEach(function (d, n) { d.setAttribute('aria-current', n === i ? 'true' : 'false'); });
        slides.forEach(function (s, n) { s.setAttribute('aria-hidden', n === i ? 'false' : 'true'); s.inert = n !== i; });
      }
      function stop() { if (timer) { clearInterval(timer); timer = null; } }
      function start() {
        stop();
        if (!delay || reduce || userPaused || hovering || slides.length < 2) return;
        timer = setInterval(function () { go(index + 1); }, delay);
      }

      var onScroll = function () {
        var w = track.clientWidth || 1;
        var i = Math.round(track.scrollLeft / w);
        if (i !== index) mark(i);
      };
      track.addEventListener('scroll', function () { window.requestAnimationFrame(onScroll); }, { passive: true });

      dots.forEach(function (d) { d.addEventListener('click', function () { go(parseInt(d.dataset.dot, 10)); start(); }); });
      var prev = root.querySelector('[data-prev]'), next = root.querySelector('[data-next]');
      if (prev) prev.addEventListener('click', function () { go(index - 1); start(); });
      if (next) next.addEventListener('click', function () { go(index + 1); start(); });
      if (pauseBtn) pauseBtn.addEventListener('click', function () {
        userPaused = !userPaused;
        root.classList.toggle('is-paused', userPaused);
        pauseBtn.setAttribute('aria-label', userPaused ? 'Play slideshow' : 'Pause slideshow');
        userPaused ? stop() : start();
      });
      root.addEventListener('mouseenter', function () { hovering = true; stop(); });
      root.addEventListener('mouseleave', function () { hovering = false; start(); });
      root.addEventListener('focusin', function () { hovering = true; stop(); });
      root.addEventListener('focusout', function () { hovering = false; start(); });
      track.addEventListener('touchstart', function () { userPaused = true; root.classList.add('is-paused'); stop(); }, { passive: true });
      root.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { go(index + 1); }
        if (e.key === 'ArrowLeft') { go(index - 1); }
      });
      if (reduce && pauseBtn) { root.classList.add('is-paused'); }
      mark(0);
      start();
    }
    function boot() { document.querySelectorAll('[data-hero-slides]').forEach(init); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
    document.addEventListener('shopify:section:load', boot);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.addEventListener('click', function (e) {
      var opener = e.target.closest('[data-size-guide-open]');
      if (opener) {
        var dlg = document.getElementById(opener.getAttribute('aria-controls'));
        if (dlg && typeof dlg.showModal === 'function') { dlg.showModal(); }
        return;
      }
      if (e.target.closest('[data-size-guide-close]')) { var d = e.target.closest('dialog'); if (d) d.close(); return; }
      if (e.target.matches && e.target.matches('dialog[data-size-guide]')) { e.target.close(); }
    });
  })();
  (function () {
    var mq = window.matchMedia('(max-width: 899px)');
    document.querySelectorAll('[data-product-section]').forEach(function (section) {
      var track = section.querySelector('[data-gallery-track]');
      var dotsWrap = section.querySelector('[data-gallery-dots]');
      if (!track || !dotsWrap) return;
      var slides = Array.prototype.slice.call(track.querySelectorAll('.gallery__slide'));
      var dots = Array.prototype.slice.call(dotsWrap.querySelectorAll('[data-dot]'));
      function current() { return track.clientWidth ? Math.round(track.scrollLeft / track.clientWidth) : 0; }
      function paint(i) { dots.forEach(function (d, n) { d.setAttribute('aria-current', n === i ? 'true' : 'false'); }); }
      function go(i, smooth) { track.scrollTo({ left: i * track.clientWidth, behavior: smooth ? 'smooth' : 'auto' }); paint(i); }
      var ticking = false;
      track.addEventListener('scroll', function () {
        if (ticking) return; ticking = true;
        requestAnimationFrame(function () { ticking = false; paint(current()); });
      }, { passive: true });
      dotsWrap.addEventListener('click', function (e) { var d = e.target.closest('[data-dot]'); if (d) go(+d.getAttribute('data-dot'), true); });
      new MutationObserver(function () {
        if (!mq.matches) return;
        var i = slides.findIndex(function (s) { return s.classList.contains('is-active'); });
        if (i > -1 && i !== current()) go(i, true);
      }).observe(track, { subtree: true, attributes: true, attributeFilter: ['class'] });
      function init() { if (!mq.matches) return; var i = slides.findIndex(function (s) { return s.classList.contains('is-active'); }); if (i > 0) go(i, false); }
      if (document.readyState === 'complete') init(); else window.addEventListener('load', init);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
